import { useAppSelector } from "@hooks/store"
import { getTableDataHelper } from "@thelpers/getTableDataHelper"
import verifyResponse from "@thelpers/verifyResponse"
import { getChargeInstanceDetail } from "../services/GET/getChargeInstanceDetail"
import { useCallback } from "react"
import { getExportChargeInstanceDebtors } from "../services/GET/getExportChargeInstanceDebtors"
import { customNotification } from "@UI/CustomNotification"
import { getChargeInstanceDebtorPaymentTypes } from "../services/GET/getChargeInstanceDebtorPaymentTypes"
import { createAdminPaymentCharge } from "../services/POST/createAdminPaymentCharge"
import { getChargeInstanceDebtorDetail } from "../services/GET/getChargeInstanceDebtorDetail"
import { updateChargeInstanceDebtor } from "../services/PUT/updateChargeInstanceDebtor"

export const useReceivedPaymentDetailServices = () => {

    const auth = useAppSelector(state => state.auth)

    const getChargeInstanceDetailService = useCallback(async ({
        limit,
        skip,
        find_value,
        sort_by,
        sort_order,
        setLoading,
        previousData,
        last,
        currentPage,
        actualLimit,
        charge_instance_id,
    }) => {
        const res = await getChargeInstanceDetail({ token: auth.idToken, company_id: auth.currentRol, limit, skip, sort_by, sort_order, charge_instance_id, find_value })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })

        setLoading?.(false)
        if (!status) {
            throw new Error('Error in getAllDocumentsService')
        }
        const { data, metadata } = getTableDataHelper({ data: res.data.data, metadata: res.data.metadata, skip, previousData, last, currentPage, actualLimit })

        return {
            data,
            metadata,
            charge_data: res.data.data.charge_data,
            status_metrics: res.data.data.status_metrics
        }
    }, [auth])

    const getExportChargeInstanceDebtorsService = useCallback(async ({ setLoading, charge_instance_id }) => {
        setLoading?.(true)
        try {
            //Se obtiene el blob del archivo
            const blobFile = await getExportChargeInstanceDebtors({ token: auth.idToken, charge_instance_id })
            const downloadUrl = window.URL.createObjectURL(blobFile)

            const link = document.createElement('a')
            link.href = downloadUrl
            link.download = 'Datos del cobro.xlsx'
            link.click()
            customNotification({
                notificationType: 'success',
                duration: 2,
                message: 'Datos del cobro exportados',
                description: 'Se han exportado los datos del cobro con éxito'
            })

            setTimeout(() => {
                window.URL.revokeObjectURL(downloadUrl)
            }, 1000)

            return blobFile
        } catch (error) {
            setLoading?.(false)
            console.error(error)
            return []
        }
    }, [auth])

    const getChargeInstanceDebtorPaymentTypesService = useCallback(async () => {
        const res = await getChargeInstanceDebtorPaymentTypes({ token: auth.idToken })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        if (!status) {
            throw new Error('Error in getChargeInstanceDebtorPaymentTypesService')
        }
        return res.data
    }, [auth])

    const getChargeInstanceDebtorDetailService = useCallback(async ({ setLoading, charge_instance_id, place_id }) => {
        setLoading?.(true)
        const res = await getChargeInstanceDebtorDetail({ token: auth.idToken, charge_instance_id, place_id })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: false })
        if (!status) {
            throw new Error('Error in getChargeInstanceDebtorDetailService')
        }
        return res.data
    }, [auth])

    const createAdminPaymentChargeService = useCallback(async ({ formData, setLoading }) => {
        setLoading?.(true)
        const res = await createAdminPaymentCharge({ token: auth.idToken, formData })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: true, message: 'Pago extraordinario creado' })
        if (!status) {
            setLoading?.(false)
            throw new Error('Error in createAdminPaymentChargeService')
        }
        return res.data
    }, [auth])

    const updateChargeInstanceDebtorService = useCallback(async ({ jsonData, setLoading }) => {
        setLoading?.(true)
        const res = await updateChargeInstanceDebtor({ token: auth.idToken, jsonData })
        const status = verifyResponse({ dataResponse: res.data, statusResponse: res.status, showToast: true, message: 'Datos actualizados' })
        if (!status) {
            setLoading?.(false)
            throw new Error('Error in updateChargeInstanceDebtorService')
        }
        return res.data
    }, [auth.idToken,])

    return {
        getChargeInstanceDebtorDetailService,
        getChargeInstanceDebtorPaymentTypesService,
        getChargeInstanceDetailService,
        getExportChargeInstanceDebtorsService,
        createAdminPaymentChargeService,
        updateChargeInstanceDebtorService
    }
}